import {mapActions} from "vuex";
import {
    SET_HAS_MULTI_DATES,
    SET_TAB_TITLE
} from "../store/actions/sensors";

export default {
    methods: {
        ...mapActions([SET_HAS_MULTI_DATES, SET_TAB_TITLE])
    },
    mounted() {
        this.SET_HAS_MULTI_DATES(this.containsMultiChartItem);
        this.SET_TAB_TITLE(this.tabTitle);
    }
};